import {Locations} from "./Locations";

export class Map {

  constructor(container, eventEmitter, locations, accessToken, markerUrl, markerHoverUrl) {
    const self = this;
    this.eventEmitter = eventEmitter;
    this.activeLocation = null;
    this.markerUrl = markerUrl;
    this.markerHoverUrl = markerHoverUrl;
    this.markerHeight = 68;
    this.markers = [];
    this.locations = [];
    this.popup = new mapboxgl.Popup({
      offset: {
        bottom: [0, -this.markerHeight]
      }
    });
    const bounds = new mapboxgl.LngLatBounds();
    locations.forEach(location => {
      const marker = this.createMarker(location);
      location.marker = marker;
      this.locations.push(location);
      this.markers.push(marker);
      bounds.extend(new mapboxgl.LngLat(location.geolocation.lng, location.geolocation.lat));
    });
    mapboxgl.accessToken = accessToken;
    const config = {
      container: container,
      style: 'mapbox://styles/mapbox/streets-v11',
      fitBoundsOptions: {
        padding: 100
      },
      maxZoom: 16,
      crossSourceCollisions: false,
    };
    if (!bounds.isEmpty()) {
      config.bounds = bounds;
    }
    this.map = new mapboxgl.Map(config);

    this.map.on('load', function(e){
      self.markers.forEach(marker => marker.addTo(self.map));
    });
    this.eventEmitter.on('location', function(e){
      if (e.location === self.activeLocation) {
        self.activeLocation = null;
        self.deactivateMarkers();
        self.closePopup();
        return;
      }
      self.activeLocation = e.location;
      self.deactivateMarkers();
      if (self.activeLocation !== null) {
        const marker = self.activeLocation.marker;
        if (marker) {
          const $element = $(self.activeLocation.marker.getElement());
          if ($element.length > 0) {
            $element.attr('src', self.markerHoverUrl);
          }
        }
        self.openPopup(self.activeLocation);
        self.map.setCenter([self.activeLocation.geolocation.lng, self.activeLocation.geolocation.lat]);
      }
    });
    this.map.on('click', function(e){
      self.popup.remove();
      self.activeLocation = null;
      self.deactivateMarkers();
      self.eventEmitter.trigger(jQuery.Event('location', {location: null}))
    });
  }

  remove() {
    this.map.remove();
  }

  openPopup(location) {
    const coordinates = [location.geolocation.lng, location.geolocation.lat];
    const locationsList = document.querySelector('.mCSB_container');
    const selectedLocationDiv = locationsList.querySelector(`.location[data-location-id="${location.nid}"]`)
    let html =
      `
<h4><a href="${location.url}" data-location-id="${location.nid}">${location.title}</a></h4>
<div class="location-type">${location.locationType}</div>
<address>${Locations.formatAddress(location.address)}</address>
<div class="phone">${location.phone}</div>
`;
    if (location.directions) {
      html += `<a class="directions" href="${location.directions}">Get Directions</a>`;
    }
    html += Locations.renderCurrentDaySchedule(location);

    setTimeout(() => {
      $('.list-scrollbar').mCustomScrollbar("scrollTo", `[data-location-id="${location.nid}"]`);
    }, 500);

    this.popup
      .setHTML(html)
      .setLngLat(coordinates)
      .addTo(this.map);
  }

  closePopup() {
    this.popup.remove();
  }

  createMarkerElement(location) {
    const self = this;
    const $element = $('<img />');
    $element
      .addClass('location')
      .attr('src', this.markerUrl)
      .attr('alt', location.title);
    $element.on('mouseenter', function(e){
      $element.attr('src', self.markerHoverUrl);
    });
    $element.on('mouseleave', function(e){
      if (self.activeLocation !== location) {
        $element.attr('src', self.markerUrl);
      }
    });
    $element.on('click', function(e){
      self.eventEmitter.trigger(jQuery.Event('location', { location: location }));
      e.stopPropagation(); // Important to prevent underlying map from capturing event
    });
    return $element;
  }

  createMarker(location) {
    const coordinates = [location.geolocation.lng, location.geolocation.lat];
    const marker = new mapboxgl.Marker({
      element: this.createMarkerElement(location).get(0),
      anchor: 'bottom',
    });
    marker
      .setLngLat(coordinates);
    return marker;
  }

  deactivateMarkers() {
    const self = this;
    this.markers.forEach(marker => {
      $(marker.getElement()).attr('src', self.markerUrl);
    });
  }

}
